<template>
  <div data-component="login-layout" class="flex-container flex-scrollable flex-distribute-v" >
    <img
      alt="PTC Logo"
      src="@/assets/logo.png"
      class="banner img-fluid mx-auto d-block logo"
    />
    <div>
      <img
        alt="Service Knowledge and Diagnostics"
        src="@/assets/skd-logo-dark.svg"
        class="px-3 mx-auto w-100 skd-product-name"
      />
      <img 
        v-if="isKMOffline" 
        src="@/assets/kmoffline.dark.svg" 
        class="mx-auto w-100 km-offline-indicator"
      />
    </div>
    <slot />
  </div>
</template>

<script>
//---- components ---------
//---- mixins -------------
//---- services -----------
//---- 3rd-parties --------
import { mapGetters } from "vuex";

//
// This is the layout for the login screen. It has the PTC logo on top, followed 
// by the product name, and then any content in the slot
//
export default {
  name: "login-layout",
  computed: {
    ...mapGetters({
      isKMOffline: "kmOffline/isKMOffline",
    }),
  },
};
</script>

<style scoped>
.logo {
  width: 200px;
  height: 75px;
}
.skd-product-name {
  height: 4rem;
}
.km-offline-indicator {
  height: 2.8rem;
}
</style>